import { render, staticRenderFns } from "./PalletList.vue?vue&type=template&id=22275f4e&"
import script from "./PalletList.vue?vue&type=script&lang=js&"
export * from "./PalletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports